import type { ComponentLineProps } from "../../FirstPaymentPreview/types";
import { RawLines } from "../RawLines";
import { shouldExpandFuturePayments } from "../variants/helpers";

export const RegularPriceLine = ({ preview, options }: ComponentLineProps) => {
  if (!preview.future_payments || !shouldExpandFuturePayments(preview)) {
    return null;
  }

  return <RawLines.RegularPriceLine preview={preview} options={options} />;
};
